import styled, { css } from 'styled-components';
import { Container as UploadContainer } from '../../components/Upload/styles';
import { ButtonBase } from 'components/Button/styles';

interface CardProps {
  height: string;
  padding: string;
}
export const Card = styled.div<CardProps>`
  background: ${props => props.theme.cardBackgroud};
  height: ${props => (props.height === 'full' ? '100%' : props.height)};
  min-height: 0;
  padding: ${props => props.padding};
  flex: ${props => (props.height === 'full' ? '1 1' : 'auto auto')};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${props =>
    props.theme.name === 'dark'
      ? css`
          box-shadow: 0 1px 20px 0 rgba(0, 0, 0, 0.1);
        `
      : css`
          box-shadow: 0 1px 15px 0 hsla(0, 0%, 48.2%, 0.05);
        `}

  header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0px 15px;
    height: 40px;
  }
`;
export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
    width: -webkit-fill-available;
    width: -moz-available;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    /* border: 3px solid white; */


  >header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    div{
      display: flex;
      align-items: center;
      min-width: 250px;
      width: 100%;
    }
    h4{
      min-width: 130px;
    }
  }
`;

export const Content = styled.div`
  display: flex;
  margin: 0;
  flex: 1 1;
  flex-direction: column;
  min-height: 0;
  > header {
    display: flex;
    margin: 0;
    padding: 0;
    padding-bottom: 10px;
    justify-content: space-between;

    ${UploadContainer} {
      width: auto !important;
    }
  }
`;

export const Header = styled.div`
  flex-grow: auto;
  display: flex;
  padding-bottom: 10px;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  ${ButtonBase} {
    margin: 0 10px 0 0 !important;
    min-width: 170px !important;
  }
`;

export const ContentButton = styled.div`
  display: flex;

  align-items: center;
  justify-content: center;
  height: 48px;
`;

// export const FiStyledCircle = styled(FiCircle)`
//   color: ${props =>
//     props.active ? props.theme.fontColor : props.theme.selectedPage};
// `;
